export default __webpack_public_path__ + "locales/zh-CN/MainBar.json?hash=ac9d19b2c84bcbb11dcba1f12fb796d4";